"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _index = _interopRequireDefault(require("date-fns/locale/es/_lib/formatDistance/index.js"));
var _index2 = _interopRequireDefault(require("./_lib/formatLong/index.js"));
var _index3 = _interopRequireDefault(require("date-fns/locale/es/_lib/formatRelative/index.js"));
var _index4 = _interopRequireDefault(require("date-fns/locale/es/_lib/localize/index.js"));
var _index5 = _interopRequireDefault(require("date-fns/locale/es/_lib/match/index.js"));
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish (Ecuador) locale.
 * @language Spanish
 * @iso-639-2 spa
 */
var locale = {
  code: 'esEC',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 1,
    /* Monday */
    firstWeekContainsDate: 1
  }
};
var _default = exports.default = locale;